import { usePageTitle } from 'slab'

import { CenteredLayout } from '../../pages/employer_onboarding/CenteredLayout'

export function InvalidOrExpiredLinkPage () {
  usePageTitle('Invalid link')

  return (
    <CenteredLayout>
      <CenteredLayout.Header
        heading='Invalid link'
        subheading='This link is invalid or expired. Please contact us at support@thatch.com to receive a new one.'
      />
    </CenteredLayout>
  )
}
